import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "../../index"

export const selectCurrentUser = createSelector(
  (state: RootState) => state.user,
  (user) => ({ data: user })
)

export const selectCurrentUserLocation = createSelector(
  (state: RootState) => state?.user?.location,
  (location) => ({ data: location || 0 })
)

export const selectCurrentUserDiggingSpeed = createSelector(
  (state: RootState) => state.user.currentDiggingSpeed,
  (speed) => ({ data: speed })
)

export const selectCurrentUserDiggingSpeedWithLocationBonus = createSelector(
  (state: RootState) => state?.mining?.locations?.current?.diggingSpeed || 0,
  (state: RootState) => state?.user?.currentDiggingSpeed || 0.1,
  (locationSpeedBonus, userDiggingSpeed) => ({
    data: userDiggingSpeed + locationSpeedBonus
  })
)

export const selectIsDogSleeping = createSelector(
  (state: RootState) => state?.user?.rank,
  (rank) => ({ data: rank < 0 })
)

export default {
  selectCurrentUser,
  selectCurrentUserDiggingSpeed,
  selectCurrentUserDiggingSpeedWithLocationBonus,
  selectIsDogSleeping,
  selectCurrentUserLocation
}
